import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { apiFetch, useAuth } from "@/auth/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const run = async () => {
      try {
        const r = await apiFetch("/api/auth/session", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error("exchange failed");
        const user = await r.json();
        setUser(user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user } });
      } catch {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    };
    run();
  }, [location.hash, navigate, setUser]);

  return <div data-testid="auth-callback" className="min-h-screen bg-sand" />;
}
